/* eslint-disable */
class Singleton {
  list = {};

  set(key, obj) {
    this.list[key] = obj;
  }

  get(key) {
    return this.list[key];
  }
}

export default new Singleton();
